/* eslint-disable import/no-cycle */
import buildReduxMain from '../../../../../commons/redux/dynamic/Filters/Main/index';
// eslint-disable-next-line import/no-cycle
import buildReduxCustomers from '../../../../../commons/redux/dynamic/Filters/Customers/index';

export const createFiltersRedux = ({
	namespace = '',
	rootSliceKey = '',
	filtersStatePropKey = 'filters'
}) => {
	const mainRedux = buildReduxMain({
		namespace,
		rootSliceKey,
		filtersStatePropKey
	});
	const customersRedux = buildReduxCustomers({
		namespace,
		rootSliceKey,
		mainRedux,
		filtersStatePropKey,
		filterStatePropKey: 'customers'
	});

	const selectors = {
		...customersRedux.selectors,
		...mainRedux.selectors
	};

	const actions = {
		...customersRedux.actions,
		...mainRedux.actions
	};

	const reducerParts = {
		...customersRedux.reducerParts,
		...mainRedux.reducerParts
	};

	const { initialState } = mainRedux;
	initialState[filtersStatePropKey].customers = customersRedux.initialState;

	return {
		selectors,
		actions,
		reducerParts,
		initialState
	};
};

export default createFiltersRedux;
